export namespace SidebarStates {
    export function sidebarStatesFactory() {
        const sideBar = {
            selectedSection: {
                timestamp: new Date(),
                section: '1'
            }
        };
        return sideBar;
    }

    export function mutations() {
        return {
            selectSection(state: any, sectionName: any) {
                state.sideBar.selectedSection.timestamp = new Date();
                state.sideBar.selectedSection.section = sectionName;
            },
        };
    }
}
